import { useAdminUpdate } from '@reapitform/hooks'
import { AdminPdfTemplate, AdminPdfTemplatePayload } from '../types'

/** Uploads a new PDF template via multipart (`POST …/pdf-templates`). Call with FormData. */
export const useUploadAdminPdfTemplate = (formReferenceID: string, versionReferenceID: string) =>
  useAdminUpdate<FormData, AdminPdfTemplate>({
    path: `/api/forms/${formReferenceID}/versions/${versionReferenceID}/pdf-templates`,
    method: 'POST',
    errorMessage: 'Failed to upload the PDF template',
    successMessage: 'PDF template uploaded',
  })

/** Updates a PDF template's name/flags (`PUT …/pdf-templates/{ref}`). */
export const useUpdateAdminPdfTemplate = (
  formReferenceID: string,
  versionReferenceID: string,
  templateReferenceID: string,
) =>
  useAdminUpdate<AdminPdfTemplatePayload, AdminPdfTemplate>({
    path: `/api/forms/${formReferenceID}/versions/${versionReferenceID}/pdf-templates/${templateReferenceID}`,
    method: 'PUT',
    errorMessage: 'Failed to update the PDF template',
    successMessage: 'PDF template updated',
  })
